import jwtDecode from 'jwt-decode';

var isValidToken = () => {
  var expiresAt = Number(localStorage.getItem('MDM_ACCESS_TOKEN_EXPIRES_AT'));
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < expiresAt);
};

var decodedToken = () => jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN'));

var hasApiAudience = (_ref) => {
  var {
    apiName
  } = _ref;
  var {
    aud
  } = decodedToken();
  return Array.isArray(aud) && aud.includes(apiName) || aud === apiName;
};

var hasToken = () => !!localStorage.getItem('MDM_ACCESS_TOKEN');

export { isValidToken, hasApiAudience, decodedToken, hasToken };